export default Object.freeze({
    STORAGE_KEY: 'ls_translations',
});
